import React, { useState, useEffect } from "react";
import TrafficChatReport from './AnalyticalReports/TrafficChatRatio'
import MeaningfullChat from './AnalyticalReports/MeaningfulChats'
import AverageResponseTimeEngagement from './AnalyticalReports/AverageResponseTime'
import WebsiteDistribution from './AnalyticalReports/WebsiteDistribution'
import WeeklyChatNumber from './ChatWiseReports/ChatNumberperWeekDay'
import ChatDetailVisitor from './ChatWiseReports/ChatDetailVisitor'
import VisitorInfoTranscript from './ChatTranscriptReports/VisitorInfoTranscript'
import ListAllchatsTranscript from './ChatTranscriptReports/ListAllChatTranscript'
import ChatsTranscriptLinks from './ChatTranscriptReports/ChatTranscriptLinks'
import BillableChatTranscript from './ChatTranscriptReports/BillableChatWebsite'
import PageWiseChatReport from './OtherReports/PageWisseChatReport'
import RatingWiseReport from './OtherReports/RatingWiseReport'
import CountryWiseReport from './OtherReports/CountryWiseReport'
import MonthWiseStatisticsLicense from './MonthWiseReports/MonthwiseStatisticsLicense'
import MonthlyTrafficReport from './MonthWiseReports/MonthlyTrafficReport'
import MonthlyChatGraph from './MonthWiseReports/MonthlyChatCountGraph'
import MonthlyAccountSummary from './MonthWiseReports/MonthlyAccountSummary'
import MultipleMonthlyAccountSummary from './MonthWiseReports/MultipleMonthlyAccSummary'
import HourWiseChatReport from './HourWiseReports/HourwiseChats'
import WebsiteHourWiseChatReport from './HourWiseReports/HourwiseWebsiteChats'
import CompanyHourWiseChatReport from './HourWiseReports/HourWiseCompanyChats'
import DepVsDealerManageGraph from './ComparisonReports/DepVsDealerManage'
import LaVsDealerManageGraph from './ComparisonReports/LaVsDealerManage'
import { t } from "i18next";
import PPCOrganicChatTranscript from './ChatTranscriptReports/PPCOrganicChat'
import HourlyVisitorsCount from './HourWiseReports/HourlyVisitorCount'
import ChatCountCompany from './ChatWiseReports/ChatCountCompany'
import DailyGrowthLeads from './AnalyticalReports/DailyGrowthLeads'
import LocationWiseReport from './OtherReports/LocationWiseReport'
import MASMultipleMonths from './MonthWiseReports/MAS(MultipleMonths)'
import NoAgentChats from "./ChatWiseReports/NoAgentChats"
import HourlyChatCountAgentWise from "./HourWiseReports/HourlyChatAgentwise"
import DepartmentWiseChatReport from "./DepartmentWiseChatReport/DepartmentWiseChatReport";
import BotAnalysisReport from "./BotReport/botAnalysisReport";
import InsightsReport from "./InsightReport/InsightsReport";
import ChatsOverviewReport from "./ChatsOverviewReport/ChatsOverviewReport";
// Sub-routes configuration for Reports Screen submenu
export const reportsScreenSubRoutes = () => {

    return [
        {
            path: "/Analytical-Reports",
            isSubMenu: true,
            showInMenu: true,
            heading: t("DashboardReports.Analytical-Report"),
            subArray: [
                {
                    heading: t("DashboardReports.AvgRespTimeEngagement"),
                    Component: <AverageResponseTimeEngagement />,
                    interfaceName: "Average Response Time and Engagement",
                    path: "/Average-Response-Time-Engagement"
                },
                {
                    heading: t("DashboardReports.TrafficChatConversionRatios"),
                    Component: <TrafficChatReport />,
                    interfaceName: "Traffic Chat Conversion Ratios",
                    path: "/Traffic-Chat-Conversion-Ratios"
                },
                {
                    heading: t("DashboardReports.Dailygrowth-leadsReport"),
                    Component: <DailyGrowthLeads />,
                    interfaceName: "Daily growth of the leads",
                    path: "/Daily-growth-of-the-leads"
                },
                {
                    heading: t("DashboardReports.MeaningfulChats-WeekdaysWeekend"),
                    Component: <MeaningfullChat />,
                    path: "/Meaningful-Chats-for-Weekdays-Weekend",
                    interfaceName: "Meaningful Chats for Weekdays / Weekend"
                },
                {
                    heading: t("DashboardReports.WebDistribution-Report"),
                    Component: <WebsiteDistribution />,
                    path: "/Website-Distribution-Report",
                    interfaceName: "Website Distribution Report"
                }
            ]
        },
        {
            path: "/Comparison-Reports",
            isSubMenu: true,
            showInMenu: true,
            heading: t("DashboardReports.Comparison-Report"),
            subArray: [
                {
                    heading: t('DashboardReports.DEPVSDealer-Managed(Graphs)'),
                    Component: <DepVsDealerManageGraph />,
                    path: "/DEP-VS-Dealer-Managed(Graphs)",
                    interfaceName: "DEP VS Dealer Managed (Graphs)"
                },
                {
                    heading: t('DashboardReports.LAVSDealer-Managed(Graphs)'),
                    Component: <LaVsDealerManageGraph />,
                    path: "/LA-VS-Dealer-Managed(Graphs)",
                    interfaceName: "LA VS Dealer Managed (Graphs)"
                }
            ]
        },
        {
            path: "/Chat-Wise-Reports",
            isSubMenu: true,
            showInMenu: true,
            heading: t("DashboardReports.ChatWise-Report"),
            subArray: [
                {
                    heading: t("DashboardReports.ChatDetailsw.r.t.Visitor"),
                    Component: <ChatDetailVisitor />,
                    path: "/Chat-Details-w.r.t.Visitor",
                    interfaceName: "Chat Details w.r.t. Visitor"
                },
                {
                    heading: t("DashboardReports.NoofChatsbyAgent-Report"),
                    Component: <NoAgentChats />,
                    path: "/No-of-Chats-by-Agent",
                    interfaceName: "No of Chats by Agent"
                },
                {
                    heading: t("DashboardReports.ChatCount-CompanyReport"),
                    Component: <ChatCountCompany />,
                    interfaceName: "Chat Count by Company",
                    path: "/Chat-Count-by-Company"
                },
                {
                    heading: t("DashboardReports.ChatNumbers-Week"),
                    Component: <WeeklyChatNumber />,
                    path: "/Chat-Numbers-per-Day-of-Week",
                    interfaceName: "Chat Numbers per Day of Week"
                },
                {
                    heading: t("DashboardReports.DepartmentWiseChatReport"),
                    Component: <DepartmentWiseChatReport />,
                    path: "/Department-Wise-Chats-Report",
                    interfaceName: "Department Wise Chats Report"
                },
                {
                    heading: t("DashboardReports.ChatsOverviewReport"),
                    Component: <ChatsOverviewReport />,
                    path: "/Chats-Overview-Report",
                    interfaceName: "Chat Reporting"
                }
            ]
        },
        {
            path: "/Hours-Wise-Reports",
            isSubMenu: true,
            showInMenu: true,
            heading: t('DashboardReports.HoursWise-Report'),
            subArray: [
                {
                    heading: t('DashboardReports.HourWiseChats-Report'),
                    Component: <HourWiseChatReport />,
                    path: "/Hour-Wise-Chats",
                    interfaceName: "Hour Wise Chats"
                },
                {
                    heading: t('DashboardReports.HWChats-WebsiteReport'),
                    Component: <WebsiteHourWiseChatReport />,
                    path: "/HourWise-Chats-of-Website",
                    interfaceName: "Hour Wise Chats of Website"
                },
                {
                    heading: t('DashboardReports.HWChats-CompanyReport'),
                    Component: <CompanyHourWiseChatReport />,
                    path: "/HourWise-Chats-of-Company",
                    interfaceName: "Hour Wise Chats of a Company"
                },
                {
                    heading: t('DashboardReports.HourlyChatCount-AgentWiseReport'),
                    Component: <HourlyChatCountAgentWise />,
                    path: "/Hourly-Chat-Count-Agent-Wise",
                    interfaceName: "Hourly Chat Count Agent Wise"
                },
                {
                    heading: t('DashboardReports.HourlyVisitorsCount-Report'),
                    Component: <HourlyVisitorsCount />,
                    path: "/Hourly-Visitors-Count",
                    interfaceName: "Hourly Visitors’ Count"
                }
            ]
        },
        {
            path: "/Month-Wise-Reports",
            isSubMenu: true,
            showInMenu: true,
            heading: t('DashboardReports.MonthWise-Report'),
            subArray: [
                {
                    heading: t('DashboardReports.Monthwise-ChatCountGraphs'),
                    Component: <MonthlyChatGraph />,
                    path: "/Month-wise-Chat-Count-Graphs",
                    interfaceName: "Month-wise Chat Count Graphs"
                },
                {
                    heading: t('DashboardReports.MonthWiseStatistics-License'),
                    Component: <MonthWiseStatisticsLicense />,
                    path: "/Month-Wise-Statistic-of-License",
                    interfaceName: "Month Wise Statistic of License"
                },
                {
                    heading: t('DashboardReports.MonthlyAccountSummary'),
                    Component: <MonthlyAccountSummary />,
                    path: "/Monthly-Account-Summary",
                    interfaceName: "Monthly Account Summary"
                },
                {
                    heading: t('DashboardReports.MonthlyTrafficReport'),
                    Component: <MonthlyTrafficReport />,
                    path: "/Monthly-Traffic-Report",
                    interfaceName: "Monthly Traffic Report"
                },
                {
                    heading: t('DashboardReports.MultipleMonthlyAccountSummary'),
                    Component: <MultipleMonthlyAccountSummary />,
                    path: "/Multiple-Monthly-Account-Summary",
                    interfaceName: "Multiple Monthly Account Summary"
                },
                {
                    heading: t("DashboardReports.MAS(Multiple-Months)-Report"),
                    Component: <MASMultipleMonths />,
                    path: "/Monthly-Account-Summary-MultipleMonths",
                    interfaceName: "Monthly Account Summary (Multiple Months)"
                },
                // {
                //     heading: "Daywise Account Summary (Eagle Hills)",
                //     Component: "Daywise Account Summary (Eagle Hills)",
                //     path: "/Daywise-Account-Summary(Eagle Hills)"
                // }
            ]
        },
        {
            path: "/Chat-Transcript-Reports",
            isSubMenu: true,
            showInMenu: true,
            heading: t('DashboardReports.ChatTranscript-Report'),
            subArray: [
                {
                    heading: t('DashboardReports.ListAllChat-TranscriptsReport'),
                    Component: <ListAllchatsTranscript />,
                    path: "/List-All-Chat-Transcripts",
                    interfaceName: "List All Chat Transcripts"
                },
                {
                    heading: t('DashboardReports.VisitorInfo-WithTranscript'),
                    Component: <VisitorInfoTranscript />,
                    path: "/Visitor-Info-With-Transcript",
                    interfaceName: "Visitor Info with Transcript"
                },
                {
                    heading: t('DashboardReports.AllChat-TranscriptsLinks'),
                    Component: <ChatsTranscriptLinks />,
                    path: "/All-Chats-Transcripts-with-Links",
                    interfaceName: "All chat transcripts with links"
                },
                {
                    heading: t('DashboardReports.BillableChats-TranscriptsReports'),
                    Component: <BillableChatTranscript />,
                    path: "/Billable-Chats-Transcript-of-Website",
                    interfaceName: "Billable Chats Transcripts of Website"
                },
                {
                    heading: t('DashboardReports.PPC/Organic-ChatTranscriptReport'),
                    Component: <PPCOrganicChatTranscript />,
                    path: "/PPC-Organic-Chat-Transcript-Of-Website",
                    interfaceName: "PPC/Organic Chat Transcript Of Website"
                }
            ]
        },
        {
            path: "/Bot-Report",
            isSubMenu: true,
            showInMenu: true,
            heading: t("DashboardReports.BotAnalysisReport"),
            subArray: [
                {
                    heading: t("DashboardReports.BotAnalysisReport"),
                    Component: <BotAnalysisReport />,
                    path: "/Bot-Analysis-Report",
                    interfaceName: "Bot Analysis Report"
                }
            ]
        },
        {
            path: "/Chats-AI-Insights",
            isSubMenu: true,
            showInMenu: true,
            heading: t('DashboardReports.ChatsAI-Insights'),
            subArray: [
                {
                    heading: t('DashboardReports.ChatsAI-Insights'),
                    Component: <InsightsReport />,
                    path: "/Chats-AI-Insights",
                    interfaceName: "Chats AI Insights"
                }
            ]
        },
        {
            path: "/Other-Reports",
            isSubMenu: true,
            showInMenu: true,
            heading: t('DashboardReports.Other-Report'),
            subArray: [
                {
                    heading: t('DashboardReports.CountryWise-Report'),
                    Component: <CountryWiseReport />,
                    path: "/Country-Wise-Report",
                    interfaceName: "Country Wise Report"
                },
                {
                    heading: t('DashboardReports.RatingWise-Report'),
                    Component: <RatingWiseReport />,
                    path: "/Rating-Wise-Report",
                    interfaceName: "Rating wise report"
                },
                {
                    heading: t("DashboardReports.LocationWise-Report"),
                    Component: <LocationWiseReport />,
                    path: "/Location-Wise-Report",
                    interfaceName: "Location wise Report"
                },
                {
                    heading: t('DashboardReports.PageWiseChat-Report'),
                    Component: <PageWiseChatReport />,
                    path: "/Page-Wise-Chat-Report",
                    interfaceName: "Page wise chat Report"
                }
            ]
        }
    ];
}